import { render, staticRenderFns } from "./DeviceManagerAssignment.vue?vue&type=template&id=1fae4efe&scoped=true"
import script from "./DeviceManagerAssignment.vue?vue&type=script&lang=js"
export * from "./DeviceManagerAssignment.vue?vue&type=script&lang=js"
import style0 from "./DeviceManagerAssignment.vue?vue&type=style&index=0&id=1fae4efe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fae4efe",
  null
  
)

export default component.exports